import Router from 'vue-router'
import goTo from '../node_modules/vuetify/es5/services/goto'
// Vuex
import store from './store.js';

// const HelloWorld = () => import('./components/HelloWorld.vue')
// const Test = () => import('./components/Test.vue')
// const temp = () => import('./components/TestReserve.vue')
const Home = () => import('./components/top/Index.vue')
const Dashboard = () => import('./components/top/Dashboard.vue')
const Page403 = () => import('./components/Page403.vue')
const Page404 = () => import('./components/Page404.vue')
const reportDownloads = () => import('./components/reportDownloads/Index.vue')
const materialCategories = () => import('./components/materialCategories/Index.vue')
const materials = () => import('./components/materials/Index.vue')
const receiptBillAnalyze = () => import('./components/receipts/BillAnalyzes.vue')
const receiptAnalyzeHistory = () => import('./components/receipts/BillAnalyzeHistory.vue')
const materialProfitAnalyzeHistories = () => import('./components/receipts/MaterialProfitAnalyzeHistories.vue')
const receiptHistory = () => import('./components/receipts/Histories.vue')
const Payment = () => import('./components/payment/Index.vue')
const Alipay = () => import('./components/payment/Alipay.vue')
const Chinapay = () => import('./components/payment/Chinapay.vue')
const WechatPay = () => import('./components/payment/WechatPay.vue')
const WechatV3Pay = () => import('./components/payment/WechatV3Pay.vue')
const WechatB2BPay = () => import('./components/payment/WechatB2BPay.vue')
const LftPay = () => import('./components/payment/LftPay.vue')
const NewlandPay = () => import('./components/payment/NewlandPay.vue')
const EasyPay = () => import('./components/payment/EasyPay.vue')
const HfPay = () => import('./components/payment/HfPay.vue')
const WsPay = () => import('./components/payment/WsPay.vue')
const HfdgPay = () => import('./components/payment/HfdgPay.vue')
const SxfPay = () => import('./components/payment/SxfPay.vue')
const CCBPay = () => import('./components/payment/CCBPay.vue')
const LKLPay = () => import('./components/payment/LKLPay.vue')
const LCSWPay = () => import('./components/payment/LCSWPay.vue')
const LCSWCBKPay = () => import('./components/payment/LCSWCBKPay.vue')
const CrowdPay = () => import('./components/payment/CrowdPay.vue')
const receipts = () => import('./components/receipts/Index.vue')
const paymentBatch = () => import('./components/paymentBatch/Index.vue')
const receiptDetail = () => import('./components/receipts/Detail.vue')
const unit = () => import('./components/unit/Index.vue')
const templates = () => import('./components/templates/Index.vue')
const templateDetails = () => import('./components/templates/NewDetail.vue')
const materialOrderRules = () => import('./components/materialOrderRules/Index.vue')
const materialOrderRuleDetail = () => import('./components/materialOrderRules/Detail.vue')
const materialOrderRuleAuto = () => import('./components/materialOrderRules/Auto.vue')
const materialOrderRuleCombineMaterial = () => import('./components/materialOrderRules/CombineMaterial.vue')
const materialOrderRuleExpressFee = () => import('./components/materialOrderRules/ExpressFee.vue')
const materialOrderRuleforceOrder = () => import('./components/materialOrderRules/ForceOrder.vue')
const materialOrderRuleMaxQuantity = () => import('./components/materialOrderRules/MaxQuantity.vue')
const materialOrderRuleMinAmount = () => import('./components/materialOrderRules/MinAmount.vue')
const materialOrderRuleMinQuantity = () => import('./components/materialOrderRules/MinQuantity.vue')
const materialOrderRuleQuantity = () => import('./components/materialOrderRules/Quantity.vue')

const materialShowCategories = () => import('./components/materialShowCategories/Index.vue')
const materialCoupons = () => import('./components/materialCoupons/Index.vue')
const materialCouponDetails = () => import('./components/materialCoupons/Detail.vue')
const materialCouponReceiveHistories = () => import('./components/materialCoupons/ReceiveHistories.vue')
const alliances = () => import('./components/alliances/Index.vue')
const alliancesEditShop = () => import('./components/alliances/EditShop.vue')
const shops = () => import('./components/shops/Index.vue')
const districts = () => import('./components/districts/Index.vue')
const registers = () => import('./components/registers/Index.vue')
const recipes = () => import('./components/recipes/Index.vue')
const dishCategories = () => import('./components/dishCategories/Index.vue')
const dishes = () => import('./components/dishes/Index.vue')
const cookingMethods = () => import('./components/cookingMethods/Index.vue')
const dishTemplates = () => import('./components/dishTemplates/Index.vue')
const dishTemplateDetails = () => import('./components/dishTemplates/Detail.vue')
const dishLogs = () => import('./components/dishLogs/Index.vue')
const stocks = () => import('./components/stocks/Index.vue')
const stockInitialize = () => import('./components/stockOrdersIn/Detail.vue')
const stockContainers = () => import('./components/stockContainers/Index.vue')
const stockPurchaseTask = () => import('./components/stocks/PurchaseTask.vue')
const containerCategories = () => import('./components/containerCategories/Index.vue')
const stockDistricts = () => import('./components/stockDistricts/Index.vue')
const stockOrdersIn = () => import('./components/stockOrdersIn/Index.vue')
const stockOrderInPrint = () => import('./components/stockOrdersIn/stockOrderInPrint.vue')
const stockOrdersInPrint = () => import('./components/stockOrdersIn/stockOrdersInPrint.vue')
const stockOrdersInDetail = () => import('./components/stockOrdersIn/Detail.vue')
const putaway = () => import('./components/putaway/Index.vue')
const putawayDetail = () => import('./components/putaway/Detail.vue')
const stockOrdersOut = () => import('./components/stockOrdersOut/Index.vue')
const stockOrdersPickingOut = () => import('./components/stockOrdersOut/PickingOut')
const stockOrdersManualSplit = () => import('./components/stockOrdersOut/ManualSplit')
const stockOrderOutDetail = () => import('./components/stockOrdersOut/Detail.vue')
const stockOrderOutDistributionPrint = () => import('./components/stockOrdersOut/DistributionPrint.vue')
const stockOrderOutDistributionsMergePrint = () => import('./components/stockOrdersOut/DistributionsMergePrint.vue')
const stockOrdersOutDistributionPrint = () => import('./components/stockOrdersOut/DistributionsPrint.vue')
const stockOrderOutPackConfirm = () => import('./components/stockOrdersOut/StockPackConfirm.vue')
const stockOrderOutPrint = () => import('./components/stockOrdersOut/StockOrderOutPrint.vue')
const stockOrdersOutPrint = () => import('./components/stockOrdersOut/StockOrdersOutPrint.vue')
const stockOrdersOutMergePrint = () => import('./components/stockOrdersOut/StockOrdersOutMergePrint.vue')
const requisitionOutMergePrint = () => import('./components/stockOrdersOut/requisitionOutMergePrint.vue')
const deliverDetailPrint = () => import('./components/stockOrdersOut/DeliverDetailPrint.vue')
const stockTakeOrders = () => import('./components/stockTakeOrders/Index.vue')
const stockTakeOrderDetail = () => import('./components/stockTakeOrders/Detail.vue')
const requisitions = () => import('./components/requisitions/Index.vue')
const requisitionDetail = () => import('./components/requisitions/Detail.vue')
const autoRequisition = () => import('./components/requisitions/AutoRequisition.vue')
const autoRequisitionCreate = () => import('./components/requisitions/AutoRequisitionCreate.vue')
const requisitionsBatchPricing = () => import('./components/requisitionsPricing/Index.vue')
const requisitionsPricingLog = () => import('./components/requisitionsPricing/PricingLogs.vue')
const waveRules = () => import('./components/waveRules/Index.vue')
const waveSettings = () => import('./components/waveRules/WaveSettingDetail.vue')
const waves = () => import('./components/waves/Index.vue')
// const stockSortingPrint = () => import('./components/waves/StockSortingPrint.vue')
const stockSortingPrint = () => import('./components/waves/StockSortingPrintNew.vue')//分拣打印JSON定义格式
const waveDetail = () => import('./components/waves/Detail.vue')
const waveDistributionsPrint = () => import('./components/waves/DistributionsPrint.vue')
const waveShopDistributionsPrint = () => import('./components/waves/ShopDistributionsPrint.vue')
const waveGenerate = () => import('./components/waves/Generate.vue')
const stockPicking = () => import('./components/waves/StockPicking.vue')
const stockOrderBinding = () => import('./components/waves/StockOrderBinding.vue')
const stockSorting = () => import('./components/waves/StockSorting.vue')
const orders = () => import('./components/orders/Index.vue')
const orderDetails = () => import('./components/orders/Detail.vue')
const ordersPricing = () => import('./components/ordersPricing/Index.vue')
const ordersPricingLogs = () => import('./components/ordersPricing/PricingLogs.vue')
const orderDistributionPrint = () => import('./components/orders/OrderDistributionPrint.vue')
const ordersDistributionPrint = () => import('./components/orders/OrdersDistributionPrint.vue')
const orderPrint = () => import('./components/orders/OrderPrint.vue')
const ordersPrint = () => import('./components/orders/OrdersPrint.vue')
const distributions =() => import('./components/distributions/Index.vue')
const distributionDetails = () => import('./components/distributions/Detail.vue')
const distributionPrint = () => import('./components/distributions/DistributionPrint.vue')
const distributionsPrint = () => import('./components/distributions/DistributionsPrint.vue')
const examines = () => import('./components/examines/Index.vue')
// const stocksOutOrders = () => import('./components/stocksOutOrders/Index.vue')
const examineDetail = () => import('./components/examines/Detail.vue')
const examineAbnormalDetail = () => import('./components/examines/AbnormalDetail.vue')
const returnOrders = () => import('./components/returnOrders/Index.vue')
const returnOrderApply = () => import('./components/returnOrders/Apply.vue')
const returnOrderDetails = () => import('./components/returnOrders/Detail.vue')
const returnOrderPrint = () => import('./components/returnOrders/ReturnOrderPrint.vue')
const returnOrdersPrint = () => import('./components/returnOrders/ReturnOrdersPrint.vue')
const returnBaskets = () => import('./components/returnBaskets/Index.vue')
const returnBasketDetails = () => import('./components/returnBaskets/Detail.vue')
const returnBasketCreate = () => import('./components/returnBaskets/Create.vue')
const returnPurchases = () => import('./components/returnPurchases/Index.vue')
const returnPurchasesDetails = () => import('./components/returnPurchases/Detail.vue')
const organizations = () => import('./components/organizations/Index.vue')
const roles = () => import('./components/roles/Index.vue')
const accountUsers = () => import('./components/accountUsers/Index.vue')
const mySelf = () => import('./components/accountUsers/MySelf.vue')
const accountQacenter = () => import('./components/accountQacenter/Index.vue')
const processSettings = () => import('./components/systemSettings/ProcessSettings.vue')
const notification = () => import('./components/notification/Index.vue')
const bussinessSettings = () => import('./components/systemSettings/BussinessSettings.vue')
const overSellSettings = () => import('./components/systemSettings/OverSellSettings.vue')
const smsPushSetting = () => import('./components/systemSettings/SmsPushSetting.vue')
const otherSettings = () => import('./components/systemSettings/OtherSettings.vue')
const MiniProgramSettings = () => import('./components/systemSettings/MiniProgramSettings.vue')
const miniDevelopProgram = () => import('./components/systemSettings/miniDevelopProgram.vue')
const EasyPaySetting = () => import('./components/subAccountSettings/EasyPaySetting.vue')
const HfPaySetting = () => import('./components/subAccountSettings/HfPaySetting.vue')
const AbcSetting = () => import('./components/subAccountSettings/AbcSetting.vue')
const WsSetting = () => import('./components/subAccountSettings/WsSetting.vue')
const CCBSetting = () => import('./components/subAccountSettings/CCBSetting.vue')
const LKLSetting = () => import('./components/subAccountSettings/LKLSetting.vue')
const orderCycles = () => import('./components/orderCycles/Index.vue')
const positions = () => import('./components/positions/Index.vue')
const positionLabels = () => import('./components/positionLabels/Index.vue')
const stockAreas = () => import('./components/stockAreas/Index.vue')
const stockRoadway = () => import('./components/stockRoadways/Index.vue')
const currentStocks = () => import('./components/currentStocks/Index.vue')
const currentStocksDetail = () => import('./components/currentStocks/Detail.vue')
const currentPosition = () => import('./components/currentPosition/Index.vue')
const positionActivities = () => import('./components/currentPosition/Detail.vue')
const positionStockDetail = () => import('./components/currentPosition/StockDetail.vue')
const distributionUsers = ()=> import('./components/distributionUsers/Index.vue')
const configureDistributionPath = ()=> import('./components/distributionUsers/Detail.vue')
const distributionCoverage = ()=> import('./components/distributionCoverage/Index.vue')
const invalidMaterials = ()=> import('./components/distributionCoverage/InvalidMaterials.vue')
const stockDetails = ()=> import('./components/stockDetails/Index.vue') //批次管理
const stockDetailsDetail = ()=> import('./components/stockDetails/Detail.vue')
const stockDetailPrint = ()=> import('./components/stockDetails/StockDetailsPrint.vue')//批次打印
const autoSplitProduction = () => import('./components/productionPlans/AutoSplitProduction.vue') //智能拆零
const productionPlans = () => import('./components/productionPlans/Index.vue') //生产计划
const productionPlanDetail = () => import('./components/productionPlans/Detail.vue') //生产计划
const stockOrderAnalyze = ()=> import('./components/stockOrderAnalyze/Index.vue')
const purchaseStockouts = ()=> import('./components/purchases/Stockouts.vue')
const purchases = ()=> import('./components/purchases/Index.vue')
// const confirmDetail = ()=> import('./components/purchases/confirmDetail.vue')
const purchasesDetail = ()=> import('./components/purchases/Detail.vue')
const purchasePrint = ()=> import('./components/purchases/PurchasePrint.vue')
const purchasesPrint = ()=> import('./components/purchases/PurchasesPrint.vue')
const StorageDetail = ()=> import('./components/purchases/StorageDetail.vue')
const SupplierExamine = ()=> import('./components/purchases/SupplierDetail.vue')
// const FinishDetail = ()=> import('./components/purchases/FinishDetail.vue')
const stockOrderAnalyzeDetail = ()=> import('./components/stockOrderAnalyze/Detail.vue')
const suppliers = ()=> import('./components/supplier/Index.vue')
// const supplierMaterials = ()=> import('./components/supplier/Detail.vue')
const supplierMaterials = ()=> import('./components/supplier/SupplierMaterialSetting.vue')
const supplierLicences = ()=> import('./components/supplier/supplierLicences.vue')
const supplierCriteriaSetting = ()=> import('./components/supplier/supplierCriteriaSetting')
const supplierScore = ()=> import('./components/supplierScore/Index.vue')
const supplierScoreDetail = ()=> import('./components/supplierScore/Detail.vue')
const purchaseInventory = ()=> import('./components/purchaseInventory/Index.vue')
const supplierSelfPurchase = () => import('./components/supplier/supplierSelfPurchase')
const quotations = () => import('./components/quotations/Index.vue')
const quotationDetail = () => import('./components/quotations/Detail.vue')
const economies = () => import('./components/economies/Index.vue')
const economyDetail = () => import('./components/economies/Detail.vue')
// const platformSupplierMaterials = ()=> import('./components/supplier/PlatformDetail.vue')
const printTemplates = ()=> import('./components/printTemplates/Index.vue')
const cloudPrinterSetting = ()=> import('./components/printSetting/Index.vue')
const cloudPrintTemplates = ()=> import('./components/cloudPrintTemplates/Index.vue')

const stockTrucks = ()=> import('./components/stockTrucks/Index.vue')
const movePositionOrder = () => import('./components/movePositionOrder/Index.vue')
const movePositionOrderDetail = () => import('./components/movePositionOrder/Detail.vue')
const autoMovePositionOrderDetail = () => import('./components/movePositionOrder/AutoMovePositionOrder.vue')
const stockMaterials = () => import('./components/stockMaterials/Index.vue')
const accountLogs = () => import('./components/accountLogs/Index.vue')
const batchLogs = () => import('./components/batchLogs/Index.vue')
const taskLogs = () => import('./components/taskLogs/TaskLogs.vue')
const taskBatchLogs = () => import('./components/taskLogs/TaskBatchLogs.vue')
const taskSyncErrLogs = () => import('./components/taskLogs/TaskSyncErrLogs.vue')
const queueDataLogs = () => import('./components/taskLogs/QueueDataLogs.vue')
const AccountAds = () => import('./components/accountAds/Index.vue')
const AccountAdsPushToShop = () => import('./components/accountAds/Shops.vue')
const Qacenter = () => import('./components/qacenter/Index.vue')
const QuestionDetail = () => import('./components/qacenter/Detail.vue')
const QuestionCategory = () => import('./components/qacenter/Category.vue')
const StandardRequests = () => import('./components/qacenter/StandardRequests.vue')
const Announcement = () => import('./components/announcements/Index.vue')
const AnnouncementShops = () => import('./components/announcements/Shops.vue')
const AnnouncementAlliances = () => import('./components/announcements/Alliances.vue')
const AnnouncementSuppliers = () => import('./components/announcements/Suppliers.vue')
const Capital = () => import('./components/capital/Index.vue')
const SpecifiedBalance = () => import('./components/capital/SpecifiedBalance.vue')
const AccountHistory = () => import('./components/capital/AccountHistory.vue')
const BalanceCategories = () => import('./components/capital/BalanceCategories.vue')
const ShopBalanceSnapshots = () => import('./components/capital/ShopBalanceSnapshots.vue')
const FinanceBills = () => import('./components/financeBills/Index.vue')
const FinanceBillsDetail = () => import('./components/financeBills/Detail.vue')
const FinanceBillsEdit = () => import('./components/financeBills/Edit.vue')
const FinanceBillsBatchEdit = () => import('./components/financeBills/BatchEdit.vue')
const FinanceBillsNew = () => import('./components/financeBillsNew/Index.vue')
const FinanceBillsDetailNew = () => import('./components/financeBillsNew/Detail.vue')
const FinanceBillsEditNew = () => import('./components/financeBillsNew/Edit.vue')
const FinanceBillsBatchEditNew = () => import('./components/financeBillsNew/BatchEdit.vue')
const subAccountType = () => import('./components/subAccountSettings/subAccountType.vue')
const subAccount = () => import('./components/subAccountSettings/subAccount.vue')
const subAccountSettingPort = () => import('./components/subAccountSettings/subAccountSettingPort.vue')
const subAccountConfigs = () =>  import('./components/subAccountSettings/subAccountConfig.vue')
const subAccountConfigDetail = () => import('./components/subAccountSettings/subAccountConfigDetail.vue')
const shopPsi = () => import('./components/shopPsi/index.vue')
const shopPsiStockOrderAnalyze = () => import('./components/shopPsi/stockOrderAnalyze.vue')
const logisticsSetting = () => import('./components/systemSettings/LogisticsSetting.vue')
const chanjetOAuth = () => import('./components/chanjetOAuth.vue')
const logisticsApiSetting = () => import('./components/systemSettings/LogisticsApiSetting.vue')
const stockLogisticsSetting = () => import('./components/stocks/LogisticDetail.vue')
const CampaignsActivities = () => import('./components/campaigns/Activities.vue')
const Campaigns = () => import('./components/campaigns/Index.vue')
const CampaignsDetail = () => import('./components/campaigns/Detail.vue')
const SortingOutSetting = () => import('./components/stocks/SortingOutSetting.vue')
const deliveryPoint = () => import('./components/deliveryPoint/Index.vue')
const deliveryPointSetting = () => import('./components/deliveryPoint/Setting.vue')
const deliveryPointRelations = () => import('./components/deliveryPoint/Relations.vue')
const Alerts = () => import('./components/alerts/Index.vue')
const StockMaterialHistories = () => import('./components/stockMaterialHistories/Index.vue')
const StockMaterialHistoryDetail = () => import('./components/stockMaterialHistories/Detail.vue')
const IntelligentPurchaseCreate = () => import('./components/purchases/IntelligentPurchaseCreate.vue')
const PurchaseFromOrder = () => import('./components/purchases/PurchaseFromOrder.vue')
const intelligentPurchaseSelect = () => import('./components/purchases/intelligentPurchaseSelect.vue')
const PurchasePlans = () => import('./components/purchasePlans/Index.vue')
const PurchasePlanAutoRuler = () => import('./components/purchasePlans/AutoRuler.vue')
const purchasePlansDetail = () => import('./components/purchasePlans/Detail.vue')
const PurchaseTasks = () => import('./components/purchaseTasks/Index.vue')
const purchaseTasksDetail = () => import('./components/purchaseTasks/Detail.vue')
const StockOutLists = () => import('./components/purchasePlans/StockOutLists.vue')
const PurchasePlansCreate = () => import('./components/purchasePlans/PurchasePlansCreate')
const PurchasePlansEdit = () => import('./components/purchasePlans/PurchasePlansEdit')
const HuifuAccountList = () => import('./components/huifu/Index.vue')
const HuifuBindCard = () => import('./components/huifu/BindCard.vue')
const HuifuPayRecords = () => import('./components/huifuPay/Index.vue')
const HuifuCashRecords = () => import('./components/huifuCash/Index.vue')
const LakalaAccountList = () => import('./components/lakala/Index.vue')
const LakalaBindCard = () => import('./components/lakala/BindCard.vue')
const LakalaPayRecords = () => import('./components/lakalaPay/Index.vue')
const LakalaCashRecords = () => import('./components/lakalaCash/Index.vue')
const CommonSortingOut = () => import('./components/stockOrdersOut/CommonSortingOut.vue')
const waveStockPickingPrint = () => import('./components/waves/StockPickingPrint.vue')
const waveStockPickingBatchPrint = () => import('./components/waves/StockPickingBatchPrint.vue')
const DistributionsMergePrint = () => import('./components/distributions/DistributionsMergePrint.vue')
const BatchNegotiate = () => import('./components/purchases/BatchNegotiate.vue')
const WaitOutMaterialAnalyses = () => import('./components/waitOutMaterialAnalyses/Index.vue')
const waitOutMaterialAnalysePrint = () => import('./components/waitOutMaterialAnalyses/waitOutMaterialAnalysePrint.vue')
const ThirdApiSetting = () => import('./components/systemSettings/ThirdApiSetting.vue')
const subAccountEditShop = () => import('./components/subAccountSettings/EditShop.vue')
const shopStockTakePlans = () => import('./components/shopStockTakePlans/Index.vue')
const shopStockTakePlansShops = () => import('./components/shopStockTakePlans/Shops.vue')
const shopStockTakeOrders = () => import('./components/shopStockTakeOrders/Index.vue')
const shopStockTakeOrdersDetail = () => import('./components/shopStockTakeOrders/Detail.vue')
const shopStockOrdersIn = () => import('./components/shopStockOrdersIn/Index.vue')
const shopStockOrdersInDetail = () => import('./components/shopStockOrdersIn/Detail.vue')
const shopStockOrdersOut = () => import('./components/shopStockOrdersOut/Index.vue')
const shopStockOrdersOutDetail = () => import('./components/shopStockOrdersOut/Detail.vue')
const PreSell = () => import('./components/PreSell/Index.vue')
const PreSellDetail = () => import('./components/PreSell/Detail.vue')


var router = new Router({
    routes: [
        { path: '/', component: Home },//首页
        { path: '/home', component: Home },//首页
        { path: '/home/:force_login/', component: Home },//首页，接受后台跳转
        { path: '/dashboard', component: Dashboard }, // 数据可视化看板
        { path: '/from-happylike/:from/:access_token', component: Home },//首页，接受后台跳转
        { path: '/from-happylike/:from/:access_token/:redirect', component: Home },//首页，接受后台跳转
        // { path: '/test', component: Test },//！测试页，发布时要拿掉
        { path: "/purchase/stockout", component: purchaseStockouts},//缺货一览
        { path: "/purchases" ,component: purchases },//采购一览
        // { path: "/purchases/confirm/:id" ,component: confirmDetail },//采购 确认
        { path: "/print/purchase-print/:id" ,component: purchasePrint },//采购单打印
        { path: "/print/purchases-print/" ,component: purchasesPrint },//采购单批量打印
        { path: "/purchases/new-from-suppliers" ,component: purchasesDetail },//新建采购单 向供货商采购
        { path: "/purchases/new-from-products" ,component: purchasesDetail },//新建采购单 根据产品采购
        { path: "/purchases/detail/:id" ,component: purchasesDetail },//采购一览明细
        { path: '/purchases/detail/:id/:mode', component: purchasesDetail },//采购编辑、确认
        { path: "/purchases-examine" ,component: purchases },//采购验收
        { path: "/purchases-examine/supplier/:id" ,component: SupplierExamine },//采购平台供应商验收明细
        { path: "/purchases-examine/:id/:mode" ,component: StorageDetail },//采购验收明细
        { path: "/purchases-examine/:id" ,component: StorageDetail },//采购验收明细
        { path: "/purchases-examine/storage/:id" ,component: StorageDetail },//采购验收
        { path: "/supplier" ,component: suppliers },//供应商管理
        { path: "/supplier/supplier-materials/:id" ,component: supplierMaterials },//供应商设定
        { path: "/supplier/supplier-materials/:id/:mode", component: supplierMaterials },//供应商设定  
        { path: "/supplier/licences/:id" ,component: supplierLicences },//证照管理     
        { path: "/supplier/criteria-setting" ,component: supplierCriteriaSetting },//供应商评分设定
        { path: "/supplier-score" ,component: supplierScore },//供应商评分
        { path: "/supplier-score/detail" ,component: supplierScoreDetail },//供应商评分明细
        { path: "/purchase-inventory" ,component: purchaseInventory },//采购备货统计
        { path: "/supplier-self-purchase" ,component: supplierSelfPurchase },//自主采购单设置
        { path: "/quotations" ,component: quotations },//报价一览
        { path: "/quotations/:id" ,component: quotationDetail },//报价单明细
        { path: "/quotations/:id/:mode" ,component: quotationDetail },//报价单确认
        { path: "/economies" ,component: economies },//定价一览
        { path: "/economies/:id" ,component: economyDetail },//定价单明细
        { path: "/economies/:id/:mode" ,component: economyDetail },//定价单确认
        { path: "/move-position-order" , component: movePositionOrder},//移库单一览
        { path: "/move-position-order/auto-move" , component: autoMovePositionOrderDetail},//自动移库单
        { path: "/move-position-order/:id" , component: movePositionOrderDetail},//移库单详情
        { path: "/move-position-order/:id/:mode" , component: movePositionOrderDetail},//移库单编辑
        { path: "/stocks", component: stocks}, //仓配管理
        { path: "/stocks/initialize", component: stockInitialize}, //仓配管理
        { path: "/stocks/districts", component: stockDistricts}, //仓配组别
        { path: "/stocks/stock-materials", component: stockMaterials}, //仓配管理
        { path: "/current-stocks" ,component:currentStocks}, // 当前库存
        { path: "/current-stocks/:id" ,component:currentStocksDetail}, // 库存详情
        { path: "/current-position" ,component:currentPosition}, // 当前库位
        { path: "/current-position/detail/:id" ,component:positionActivities}, // 当前库位流水明细
        { path: "/current-position/stock-detail" ,component:positionStockDetail}, // 当前库位流水明细
        { path: "/stocks/stock-trucks" ,component:stockTrucks}, // 车次管理
        { path: "/stocks/distribution-users", component: distributionUsers}, // 线路管理
        { path: "/stocks/distribution-users/:id", component: configureDistributionPath }, // 门店线路
        { path: "/stocks/distribution-coverage", component: distributionCoverage }, // 配送范围
        { path: "/stocks/distribution-coverage/invalid-materials", component: invalidMaterials }, // 配送范围
        { path: "/stocks/stock-containers", component: stockContainers}, // 容器管理
        { path: "/stocks/container-categories", component: containerCategories}, // 容器分类
        { path: '/stocks/delivery-point', component: deliveryPoint }, //配送点
        { path: '/stocks/delivery-point/setting', component: deliveryPointSetting }, //配送点配置
        { path: '/stocks/delivery-point/relations', component: deliveryPointRelations }, //配送点配置
        { path: "/stocks/purchase-task", component: stockPurchaseTask}, // 采购任务设置
        { path: "/stock-orders-in", component: stockOrdersIn},//入库
        { path: "/print/stock-order-in-print/:id", component: stockOrderInPrint},//入库单打印
        { path: "/print/stock-orders-in-print/", component: stockOrdersInPrint},//入库单打印 批量
        { path: "/stock-orders-in/:id", component: stockOrdersInDetail},//入库单详情
        { path: "/stock-orders-in/:id/:mode", component: stockOrdersInDetail},//入库单编辑确认
        { path: "/putaway", component: putaway},//上架
        { path: "/putaway/:id", component: putawayDetail},//上架编辑确认
        { path: "/stock-orders-out", component: stockOrdersOut}, //出库
        { path: "/stock-orders-out/picking-out", component: stockOrdersPickingOut}, //批量分拣出库
        { path: "/stock-orders-out/manual-split", component: stockOrdersManualSplit}, //批量分拣出库
        { path: "/print/stock-out-detail-print/:id", component: stockOrderOutPrint}, //出库单明细打印
        { path: "/print/stock-orders-out-print/", component: stockOrdersOutPrint}, //出库单批量打印
        { path: "/print/stock-orders-out-merge-print/", component: stockOrdersOutMergePrint}, //出库单批量打印
        { path: "/print/stock-orders-out-merge-print-preview/", component: stockOrdersOutMergePrint}, //出库单合并预打印
        { path: "/print/requisition-out-merge-print/", component: requisitionOutMergePrint}, //批量合并打印调拨单
        { path: "/print/deliver-detail-print/:id", component: deliverDetailPrint}, //发货明细单打印
        { path: "/stock-orders-out/stock-pack-confirm", component: stockOrderOutPackConfirm},//出库单打包确认
        { path: "/stock-orders-out/:id", component: stockOrderOutDetail}, //出库单详情
        { path: "/stock-orders-out/:id/:mode", component: stockOrderOutDetail },//出库单编辑、确认
        { path: "/print/stock-orders-out-distribution-print", component: stockOrdersOutDistributionPrint}, //出库批量预打印配送单
        { path: "/print/stock-order-out-distribution-print/:id", component: stockOrderOutDistributionPrint}, //出库预打印配送单
        { path: "/print/stock-order-out-distributions-merge-print", component: stockOrderOutDistributionsMergePrint}, //出库预打印配送单
        { path: "/stock-take-orders", component: stockTakeOrders}, //盘点
        { path: "/stock-take-orders/:id", component: stockTakeOrderDetail}, //盘点详情
        { path: "/stock-take-orders/:id/:mode", component: stockTakeOrderDetail}, //盘点功能
        { path: "/requisitions", component: requisitions }, //调拨
        { path: "/requisitions/auto-requisition", component: autoRequisition }, //自动调拨
        { path: "/requisitions/auto-requisition-create", component: autoRequisitionCreate }, //自动调拨单生成
        { path: "/requisitions/out-batch-pricing", component: requisitionsBatchPricing }, //调拨出库批量核价
        { path: "/requisitions/batch-pricing", component: requisitionsBatchPricing }, //调拨入库批量改价
        { path: "/requisitions/batch-out-pricing-log", component: requisitionsPricingLog }, //调拨出库批量改价
        { path: "/requisitions/batch-pricing-log", component: requisitionsPricingLog }, //调拨入库批量改价
        { path: "/requisitions/:id", component: requisitionDetail }, //调拨详情
        { path: "/requisitions/:id/:mode", component: requisitionDetail }, //调拨编辑、确认
        { path: "/stocks/wave-rulers", component: waveRules },//波次策略
        { path: "/stocks/wave-settings", component: waveSettings },//波次设置
        { path: "/waves", component: waves },//波次一览
        { path: '/print/stock-sorting/:id', component: stockSortingPrint },//分拣打印
        { path: "/waves/:id", component: waveDetail},//波次详情
        { path: "/print/wave-distributions-print/:id", component: waveDistributionsPrint},//波次预打印配送单
        { path: "/print/wave-shop-distributions-print/:id", component: waveShopDistributionsPrint},//门店配送单打印
        { path: "/wave-generate", component: waveGenerate},//生成波次
        { path: "/waves/stock-picking/:id", component: stockPicking},//波次拣货
        { path: "/waves/stock-order-binding/:id", component: stockOrderBinding},//波次绑定容器
        { path: "/stock-order-analyze", component: stockOrderAnalyze},//出入库统计
        { path: "/stock-order-analyze/:id", component: stockOrderAnalyzeDetail},//出入库统计明细
        { path: "/waves/stock-sorting/:id", component: stockSorting},//分拣
        { path: "/stock-details", component: stockDetails },//批次管理
        { path: "/stock-details/:id", component: stockDetailsDetail },//批次管理详情
        { path: "/print/stock-details-print/:id", component: stockDetailPrint },//批次打印
        { path: "/auto-split-production", component: autoSplitProduction },//智能拆零
        { path: "/production-plans", component: productionPlans },//生产计划一览
        { path: "/production-plans/:id", component: productionPlanDetail },//生产计划详情
        { path: "/production-plans/:id/:mode", component: productionPlanDetail },//生产计划编辑
        { path: "/production-plans/:id/:mode/:action", component: productionPlanDetail },//生产计划编辑
        { path: "/production-stock-out", component: stockOrdersOut },//生产出库一览
        { path: "/production-stock-out/stock-pack-confirm", component: stockOrderOutPackConfirm},//生产出库单打包确认
        { path: "/production-stock-out/:id", component: stockOrderOutDetail },//生产出库详情
        { path: "/production-stock-out/:id/:mode", component: stockOrderOutDetail },//生产出库编辑，确认
        { path: "/production-stock-in", component: stockOrdersIn },//生产入库一览
        { path: "/production-stock-in/:id", component: stockOrdersInDetail},//生产入库单详情
        { path: "/production-stock-in/:id/:mode", component: stockOrdersInDetail},//生产入库单编辑确认
        { path: '/material-categories', component: materialCategories },//商品分类
        { path: '/materials', component: materials },//商品
        { path: '/receipts', component: receipts }, // 应收应付
        { path: '/receipts/:id', component: receiptDetail }, // 应收应付详情
        { path: '/receipt-history', component: receiptHistory },//收付款历史
        { path: '/payment', component: Payment },// 在线支付
        { path: '/payment/alipay-h5', component: Alipay },// 在线支付 -- 支付宝
        { path: '/payment/chinapay-h5', component: Chinapay },// 在线支付 -- Chinapay
        { path: '/payment/wechat-pay', component: WechatPay },// 在线支付 -- wechat-pay
        { path: '/payment/wechat-v3-pay', component: WechatV3Pay },// 在线支付 -- wechat-v3-pay
        { path: '/payment/wechat-b2b-pay', component: WechatB2BPay },// 在线支付 -- wechat-v3-pay
        { path: '/payment/lft-pay', component: LftPay },// 在线支付 -- lft-pay
        { path: '/payment/newland-pay', component: NewlandPay },// 在线支付 -- newland-pay
        { path: '/payment/easy-pay', component: EasyPay },// 在线支付 -- easy-pay
        { path: '/payment/hf-pay', component: HfPay },// 在线支付 -- hf-pay
        { path: '/payment/ws-pay', component: WsPay },// 在线支付 -- ws-pay
        { path: '/payment/hfdg-pay', component: HfdgPay },// 在线支付 -- hfdg-pay
        { path: '/payment/sxf-pay', component: SxfPay },// 在线支付 -- sxf-pay
        { path: '/payment/ccb-pay', component: CCBPay },// 在线支付 -- ccb-pay
        { path: '/payment/lkl-pay', component: LKLPay },// 在线支付 -- lkl-pay
        { path: '/payment/lcsw-pay', component: LCSWPay },// 在线支付 -- lcsw-pay
        { path: '/payment/lcsw-cbk-pay', component: LCSWCBKPay },// 在线支付 -- lcsw-cbk-pay
        { path: '/payment/crowd-pay', component: CrowdPay },// 在线支付 -- crowd-pay
        { path: '/receipt-bill-analyze', component: receiptBillAnalyze },//应收应付统计
        { path: '/receipt-bill-analyze/history', component: receiptAnalyzeHistory },//应收应付统计历史
        { path: '/receipt-bill-analyze/material-analyze-histories', component: materialProfitAnalyzeHistories },//应收应付统计商品毛利分析
        { path: '/payment-batch', component: paymentBatch }, // paymentBatch
        { path: '/unit', component: unit },//计量单位
        { path: '/material-show-categories', component: materialShowCategories },//商品展示分类
        { path: '/material-coupons', component: materialCoupons },//优惠券
        { path: "/material-coupons/detail/:id", component: materialCouponDetails},//优惠券明细
        { path: "/material-coupons/detail/:id/:mode", component: materialCouponDetails },//优惠券明细
        { path: "/material-coupons/receive-histories/:id", component: materialCouponReceiveHistories},//优惠券领取记录
        { path: '/alliances', component: alliances }, //销售
        { path: '/alliances/edit-shop/:id', component: alliancesEditShop }, //销售管理下属门店
        { path: '/shops', component: shops }, //要货商
        { path: '/districts', component: districts }, //组别
        { path: '/material-order-rules', component: materialOrderRules },//商品规则
        // { path: '/material-order-rule-new', component: materialOrderRuleDetail },//商品规则新建
        { path: '/material-order-rules/:id', component: materialOrderRuleDetail },//商品规则编辑
        { path: '/material-order-rules/min_quantity/:id', component: materialOrderRuleMinQuantity },//最小订货规则
        { path: '/material-order-rules/max_quantity/:id', component: materialOrderRuleMaxQuantity },//最大订货规则
        { path: '/material-order-rules/quantity/:id', component: materialOrderRuleQuantity },//数量匹配规则
        { path: '/material-order-rules/auto/:id', component: materialOrderRuleAuto },//自动标配规则
        { path: '/material-order-rules/min_amount/:id', component: materialOrderRuleMinAmount },//最小订货金额规则
        { path: '/material-order-rules/combine_material/:id', component: materialOrderRuleCombineMaterial },//组合商品规则
        { path: '/material-order-rules/express_fee/:id', component: materialOrderRuleExpressFee },//运费计算规则
        { path: '/material-order-rules/force-order/:id', component: materialOrderRuleforceOrder },//强制订货规则


        { path: '/registers', component: registers }, //组别
        { path: '/templates', component: templates },//商品模板
        { path: '/templates/:id', component: templateDetails },//商品模板价格展示和设置
        { path: '/templates/:id/:mode', component: templateDetails },//商品模板价格展示和设置
        { path: '/dish-categories', component: dishCategories }, //菜品分类
        { path: '/dishes', component: dishes }, //菜品一览
        { path: '/dishes/cooking-methods', component: cookingMethods }, //菜品一览
        { path: '/recipes', component: recipes }, //配方一览
        { path: '/dish-templates', component: dishTemplates }, //菜品模板
        { path: '/dish-templates/:id', component: dishTemplateDetails },//商品模板价格展示和设置
        { path: '/dish-templates/:id/:mode', component: dishTemplateDetails },//商品模板价格展示和设置
        { path: '/dish-logs', component: dishLogs },//菜品日志
        { path: '/orders', component: orders },//订单一览
        { path: '/orders-approve', component: orders },//订单审批
        { path: '/order-stock-out', component: stockOrdersOut },//要货出库
        { path: "/order-stock-out/stock-pack-confirm", component: stockOrderOutPackConfirm},//要货出库单打包确认
        { path: "/order-stock-out/:id", component: stockOrderOutDetail },//要货出库详情
        { path: "/order-stock-out/:id/:mode", component: stockOrderOutDetail },//要货出库编辑，确认
        { path: '/order-new', component: orderDetails },//订单新建
        { path: '/orders/:id', component: orderDetails },//订单详情
        { path: '/orders/:id/:mode', component: orderDetails },//订单编辑、确认
        { path: '/orders-approve/:id', component: orderDetails },//订单详情
        { path: '/orders-approve/:id/:mode', component: orderDetails },//订单编辑、确认
        { path: '/orders-pricing', component: ordersPricing },//订单批量核价
        { path: '/orders-pricing/logs', component: ordersPricingLogs },//核价日志
        { path: '/print/order-distribution-print/:id', component: orderDistributionPrint},//预打印配送单
        { path: '/print/orders-distribution-print', component: ordersDistributionPrint},//批量预打印配送单
        { path: '/print/order-print/:id', component: orderPrint},//要货单打印
        { path: '/print/orders-print/', component: ordersPrint},//要货单批量打印
        { path: '/distributions', component: distributions },//配送单一览
        { path: '/distributions/:id', component: distributionDetails },//配送单详情
        { path: '/print/distribution-print/:id', component: distributionPrint },//配送单打印
        { path: '/print/distributions-print', component: distributionsPrint },//批量配送单打印
        { path: '/examines', component: examines },//验收一览
        { path: '/examines/:id', component: examineDetail},//验收详情
        { path: '/examines/abnormal/:id', component: examineAbnormalDetail},//验收异常详情
        { path: '/examines/abnormal/:id/:mode', component: examineAbnormalDetail},//验收异常处理
        { path: '/examines/:id/:mode', component: examineDetail},//确认验货
        { path: '/return-orders', component: returnOrders },//退货一览
        { path: '/return-order-new', component: returnOrderDetails },//退货单新建
        { path: '/return-order-apply', component: returnOrderApply },//退货单申请
        { path: '/return-orders/:id', component: returnOrderDetails },//退货单详情
        { path: '/return-orders/:id/:mode', component: returnOrderDetails },//退货单编辑、确认
        { path: '/return-orders-approve', component: returnOrders },//退货单审批认        
        { path: "/return-orders-approve/:id/:mode" ,component: returnOrderDetails },//采购验收明细
        { path: "/return-orders-approve/:id" ,component: returnOrderDetails },//采购验收明细
        { path: '/print/return-order-print/:id', component: returnOrderPrint},//退货单打印
        { path: '/print/return-orders-print/', component: returnOrdersPrint},//退货单批量打印
        { path: "/return-baskets" ,component: returnBaskets },//退框一览
        { path: "/return-baskets/new" ,component: returnBasketCreate },//创建退框单
        { path: "/return-baskets/:id" ,component: returnBasketDetails },//退框单详情
        { path: '/return-purchases', component: returnPurchases },//采购退货一览
        { path: '/return-purchase-new', component: returnPurchasesDetails },//采购退货单新建
        { path: '/return-purchases/:id', component: returnPurchasesDetails },//采购退货单详情
        { path: '/return-purchases/:id/:mode', component: returnPurchasesDetails },//采购退货单编辑、确认
        { path: '/return-purchases-approve', component: returnPurchases },//退货单审批认
        { path: "/return-purchases-approve/:id/:mode" ,component: returnPurchasesDetails },//采购验收明细
        { path: "/return-purchases-approve/:id" ,component: returnPurchasesDetails },//采购验收明细
        { path: '/orders-approve/:id/:mode', component: orderDetails },//订单编辑、确认、审批
        { path: "/stocks/positions", component: positions },//库位一览
        { path: "/stocks/position-labels", component: positionLabels },//库位标签一览
        { path: "/stocks/areas", component: stockAreas},//库区一览
        { path: "/stocks/roadways", component: stockRoadway},//巷道一览
        { path: '/qacenter', component: Qacenter },// 投诉
        { path: '/qacenter/question-detail/:id', component: QuestionDetail },// 投诉明细
        { path: '/qacenter/categories', component: QuestionCategory },// 投诉分类
        { path: '/qacenter/standard-requests', component: StandardRequests },// 标准回复
        { path: '/account-ads', component: AccountAds },// 发现
        { path: '/account-ads/push-to-shop/:id', component: AccountAdsPushToShop },// 发现-设置发布客户
        { path: '/announcement', component: Announcement },// 公告
        { path: '/announcement/push-to-shop/:id', component: AnnouncementShops },// 设置发布门店
        { path: '/announcement/push-to-alliance/:id', component: AnnouncementAlliances },// 设置发布销售
        { path: '/announcement/push-to-supplier/:id', component: AnnouncementSuppliers },// 设置发布供应商
        { path: '/capital', component: Capital },// 资金账户   
        { path: '/account-history', component: AccountHistory },// 门店历史账户
        { path: '/capital/balance-categories', component: BalanceCategories },// 余额分类
        { path: '/capital/shop-balance-snapshots', component: ShopBalanceSnapshots }, //门店余额历史一览
        { path: '/capital/specified-balance', component: SpecifiedBalance }, //余额指定消费
        { path: '/finance-bills/batch-edit', component: FinanceBillsBatchEdit },// 财务对账单批量编辑
        { path: '/finance-bills', component: FinanceBills },// 财务对账单
        { path: '/finance-bills/:id', component: FinanceBillsDetail },// 财务对账单明细
        { path: '/finance-bills/edit/:id', component: FinanceBillsEdit },// 财务对账单编辑
        { path: '/finance-bills-order/batch-edit', component: FinanceBillsBatchEditNew },// 财务对账单批量编辑(要货对账单)
        { path: '/finance-bills-order', component: FinanceBillsNew },// 财务对账单(要货对账单)
        { path: '/finance-bills-order/:id', component: FinanceBillsDetailNew },// 财务对账单明细(要货对账单)
        { path: '/finance-bills-order/edit/:id', component: FinanceBillsEditNew },// 财务对账单编辑(要货对账单)
        { path: '/finance-bills-return/batch-edit', component: FinanceBillsBatchEditNew },// 财务对账单批量编辑(退货对账单)
        { path: '/finance-bills-return', component: FinanceBillsNew },// 财务对账单(退货对账单)
        { path: '/finance-bills-return/:id', component: FinanceBillsDetailNew },// 财务对账单明细(退货对账单)
        { path: '/finance-bills-return/edit/:id', component: FinanceBillsEditNew },// 财务对账单编辑(退货对账单)
        { path: '/finance-bills-purchase/batch-edit', component: FinanceBillsBatchEditNew },// 财务对账单批量编辑(采购对账单)
        { path: '/finance-bills-purchase', component: FinanceBillsNew },// 财务对账单(采购对账单)
        { path: '/finance-bills-purchase/:id', component: FinanceBillsDetailNew },// 财务对账单明细(采购对账单)
        { path: '/finance-bills-purchase/edit/:id', component: FinanceBillsEditNew },// 财务对账单编辑(采购对账单)
        { path: '/finance-bills-purchaseReturn/batch-edit', component: FinanceBillsBatchEditNew },// 财务对账单批量编辑(采购退货对账单)
        { path: '/finance-bills-purchaseReturn', component: FinanceBillsNew },// 财务对账单(采购退货对账单)
        { path: '/finance-bills-purchaseReturn/:id', component: FinanceBillsDetailNew },// 财务对账单明细(采购退货对账单)
        { path: '/finance-bills-purchaseReturn/edit/:id', component: FinanceBillsEditNew },// 财务对账单编辑(采购退货对账单)
        { path: '/finance-bills-returnPurchase/batch-edit', component: FinanceBillsBatchEditNew },// 财务对账单批量编辑(采购原单退货对账单)
        { path: '/finance-bills-returnPurchase', component: FinanceBillsNew },// 财务对账单(采购原单退货对账单)
        { path: '/finance-bills-returnPurchase/:id', component: FinanceBillsDetailNew },// 财务对账单明细(采购原单退货对账单)
        { path: '/finance-bills-returnPurchase/edit/:id', component: FinanceBillsEditNew },// 财务对账单编辑(采购原单退货对账单)
        { path: '/finance-bills-requisition/batch-edit', component: FinanceBillsBatchEditNew },// 财务对账单批量编辑(调拨应收对账单)
        { path: '/finance-bills-requisition', component: FinanceBillsNew },// 财务对账单(调拨应收对账单)
        { path: '/finance-bills-requisition/:id', component: FinanceBillsDetailNew },// 财务对账单明细(调拨应收对账单)
        { path: '/finance-bills-requisition/edit/:id', component: FinanceBillsEditNew },// 财务对账单编辑(调拨应收对账单)
        { path: '/finance-bills-requisitionPay/batch-edit', component: FinanceBillsBatchEditNew },// 财务对账单批量编辑(调拨应收对账单)
        { path: '/finance-bills-requisitionPay', component: FinanceBillsNew },// 财务对账单(调拨应收对账单)
        { path: '/finance-bills-requisitionPay/:id', component: FinanceBillsDetailNew },// 财务对账单明细(调拨应收对账单)
        { path: '/finance-bills-requisitionPay/edit/:id', component: FinanceBillsEditNew },// 财务对账单编辑(调拨应收对账单)
        { path: '/report-downloads', component: reportDownloads },//报表下载
        { path: '/settings/print-templates', component: printTemplates },//打印模板设置
        { path: "/settings/cloud-printer-setting", component: cloudPrinterSetting },//云打印机设置
        { path: "/settings/cloud-print-templates", component: cloudPrintTemplates },//云打印模板设置
        { path: '/settings/account-logs', component: accountLogs },//管理操作日志
        { path: '/settings/batch-logs', component: batchLogs },//批处理日志
        { path: '/settings/task-logs', component: taskLogs },//任务日志
        { path: '/settings/task-batch-logs', component: taskBatchLogs },//任务批处理日志
        { path: '/settings/task-sync-err-logs', component: taskSyncErrLogs },//任务同步日志
        { path: '/settings/queue-data-logs', component: queueDataLogs },//队列日志
        { path: "/settings/organizations", component: organizations}, //组织机构
        { path: "/settings/roles", component: roles}, //组织机构
        { path: "/settings/account-users", component: accountUsers}, //员工管理
        { path: "/my-self", component: mySelf}, //自我账号修改
        { path: "/account-qacenter", component: accountQacenter }, // 需求反馈
        { path: "/notification", component: notification }, // 通知
        { path: "/settings/process-settings", component: processSettings}, //流程设置
        { path: "/settings/bussiness-settings", component: bussinessSettings}, //业务设置
        { path: "/settings/bussiness-settings/order-cycles", component: orderCycles}, //业务设置中的下单周期
        { path: "/settings/mini-program-settings", component: MiniProgramSettings},//小程序设置
        { path: "/settings/over-sell-settings", component: overSellSettings}, //防超卖设置
        { path: "/settings/sms-push-setting", component: smsPushSetting}, //推送设置
        { path: "/settings/other-settings", component: otherSettings},//其他设置
        { path: "/settings/mini-develop-program", component: miniDevelopProgram},//小程序开发设置
        { path: "/settings/sub-account-settings/sub-account-setting-port/sub-account-easy-pay-setting", component: EasyPaySetting},//易生分账业务
        { path: "/settings/sub-account-settings/sub-account-setting-port/sub-account-hf-pay-setting", component: HfPaySetting },//hf分账业务
        { path: "/settings/sub-account-settings/sub-account-setting-port/sub-account-abc-setting", component: 
        AbcSetting},//农行分账
        { path: "/settings/sub-account-settings/sub-account-setting-port/sub-account-ws-setting", component: 
        WsSetting},//网商分账
        { path: "/settings/sub-account-settings/sub-account-setting-port/sub-account-ccb-setting", component:
        CCBSetting},//建行分账
        { path: "/settings/sub-account-settings/sub-account-setting-port/sub-account-lkl-setting", component:
        LKLSetting},//拉卡拉分账
        { path: "/settings/sub-account-settings/sub-account-type", component: subAccountType },//分账类型
        { path: "/settings/sub-account-settings/sub-account", component: subAccount },//账号一览
        { path: "/settings/sub-account-settings/sub-account-setting-port", component: subAccountSettingPort },//分账接口设置
        { path: '/settings/sub-account-settings/sub-account-configs', component: subAccountConfigs }, //分账配置
        { path: '/settings/sub-account-settings/sub-account-configs/:id', component: subAccountConfigDetail }, //分账配置详情
        { path: "/shop-psi", component: shopPsi },//门店进销存查询
        { path: "/shop-stock-order-analyze", component: shopPsiStockOrderAnalyze },//门店进销存查询
        { path: '/settings/logistics-setting', component: logisticsSetting }, //物流设置
        { path: '/chanjetOauth', component: chanjetOAuth },//畅捷通授权回调页面
        { path: '/settings/logistics-api-setting', component: logisticsApiSetting }, //物流接口设置
        { path: '/stocks/stock-logistic-setting', component: stockLogisticsSetting }, //快递设置
        { path: '/campaign', component: Campaigns },//促销方案
        { path: '/campaign/select-type', component: CampaignsActivities },//促销方案类型
        { path: '/campaign/:id', component: CampaignsDetail },//促销方案类型详情
        { path: '/stocks/sorting-out-setting', component: SortingOutSetting }, //分拣出库设置
        { path: '/current-stocks/detail/stock-material-history', component: StockMaterialHistories }, //历史库存一览
        { path: '/current-stocks/detail/stock-material-history-details/:id', component: StockMaterialHistoryDetail }, //历史库存详情
        { path: '/intelligent-purchase/intelligent-purchase-create', component: IntelligentPurchaseCreate }, //智能采购单创建
        { path: '/intelligent-purchase/purchase-from-order', component: PurchaseFromOrder }, //根据要货单智能采购
        { path: '/intelligent-purchase', component: intelligentPurchaseSelect }, //智能采购单首页
        { path: '/purchase-plans', component: PurchasePlans }, //采购计划一览
        { path: '/purchase-plans/auto-ruler', component: PurchasePlanAutoRuler }, // 采购计划自动策略
        { path: '/purchase-plans/stock-out-lists', component: StockOutLists }, //采购计划单出库一览
        { path: '/purchase-plans/purchase-plans-create', component: PurchasePlansCreate }, // 生成采购计划单
        { path: '/purchase-plans/purchase-plans-edit/:id', component: PurchasePlansEdit}, // 编辑采购计划单
        { path: "/purchase-plans/detail/:id" ,component: purchasePlansDetail },//采购计划明细
        { path: '/purchase-plans/detail/:id/:mode', component: purchasePlansDetail },//采购计划下发
        { path: '/purchase-tasks', component: PurchaseTasks }, //采购任务一览
        { path: "/purchase-tasks/detail/:id" ,component: purchaseTasksDetail },//采购任务明细
        { path: '/purchase-tasks/detail/:id/:mode', component: purchaseTasksDetail },//采购任务提交
        { path: '/huifu', component: HuifuAccountList }, //汇付斗拱账户一览
        { path: '/huifu?:id', component: HuifuAccountList }, //汇付斗拱账户一览
        { path: '/huifu/bind-card/:id', component: HuifuBindCard }, //汇付斗拱绑卡入驻
        { path: '/huifu-pay', component: HuifuPayRecords }, //汇付斗拱支付一览
        { path: '/huifu-cash', component: HuifuCashRecords }, //汇付斗拱取现一览
        { path: '/lakala', component: LakalaAccountList }, //拉卡拉账户一览
        { path: '/lakala?:id', component: LakalaAccountList }, //拉卡拉账户一览
        { path: '/lakala/create-user/:id', component: LakalaBindCard }, //拉卡拉开户入驻
        { path: '/lakala-pay', component: LakalaPayRecords }, //拉卡拉支付一览
        { path: '/lakala-cash', component: LakalaCashRecords }, //拉卡拉取现一览
        { path: '/stock-orders-out/detail/common-sorting-out/:id', component: CommonSortingOut }, //出库单分拣出库
        { path: '/order-stock-out/detail/common-sorting-out/:id', component: CommonSortingOut }, //出库单分拣出库(要货出库)

        { path: "/print/wave-stockPicking-print/:id", component: waveStockPickingPrint},//分拣单打印
        { path: "/print/wave-stockPicking-batch-print/", component: waveStockPickingBatchPrint},//分拣单打印
        { path: "/print/distributions-merge-print", component: DistributionsMergePrint},//分拣单打印
        { path: "/purchases/batch-negotiate-price", component: BatchNegotiate},//批量后议价
        { path: "/wait-out-material-analyses", component: WaitOutMaterialAnalyses},//待出库统计查询
        { path: "/print/wait-out-material-analyse-print", component: waitOutMaterialAnalysePrint },//待出库统计查询批量打印
        { path: "/settings/third-api-setting", component: ThirdApiSetting },//第三方接口设置
        { path: "/settings/sub-account-settings/sub-account/edit-shop/:id", component: subAccountEditShop },//门店分账
        { path: "/stock-take-orders/detail/stock-take-plans/shop-stock-take-plans", component: shopStockTakePlans },//盘点计划单
        { path: "/stock-take-orders/detail/stock-take-plans/shop-stock-take-plans/push-to-shop/:id", component: shopStockTakePlansShops },//盘点计划单
        { path: "/shop-stock-take-orders", component: shopStockTakeOrders },//门店盘点查询
        { path: "/shop-stock-take-orders/:id", component: shopStockTakeOrdersDetail}, //门店盘点查询详情
        { path: '/shop-stock-orders-in', component: shopStockOrdersIn },//门店入库单查询
        { path: '/shop-stock-orders-in/:id/', component: shopStockOrdersInDetail },//门店入库单查询详情
        { path: '/shop-stock-orders-out', component: shopStockOrdersOut },//门店出库单查询
        { path: '/shop-stock-orders-out/:id/', component: shopStockOrdersOutDetail },//门店出库单查询详情
        { path: '/pre-sell', component: PreSell },
        { path: '/pre-sell/:id/', component: PreSellDetail },
        { path: '/pre-sell/:id/:mode', component: PreSellDetail },

        // /stock-take-orders/detail
        { path: '/alerts', component: Alerts }, //报错通知
        { path: '/page404', component: Page404 },//Page404
        { path: '/page403', component: Page403 },//Page404
        { path: '*', component: Page404 }
        
    ],
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        return goTo(scrollTo);
    },
})

router.beforeEach((to, from, next) => {
    store.commit("searchDistrict", false);// 导航切换时默认关闭侧边栏的门店分组搜索控件
    next();
})

export default router